import styled, { css } from 'styled-components';

import { RADIUS } from '~/common/layout-propertis/radius';

interface IStyContainer {
  readonly gradientColorOnHover: string;
  readonly position: string;
  readonly hasHover: boolean;
  readonly widthMinContent: boolean;
}

export const StyContainer = styled.div<IStyContainer>`
  position: relative;
  width: ${({ widthMinContent }) => (widthMinContent ? 'min-content' : '100%')};
  height: 100%;
  border-radius: ${RADIUS._4};

  ${({ hasHover }) =>
    hasHover &&
    css<IStyContainer>`
      & > div:first-of-type::after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: ${RADIUS._4};
        background: ${({ gradientColorOnHover, position }) => `
      linear-gradient(
        ${position},
        ${gradientColorOnHover} 0%,
        transparent 32%,
        transparent 63%,
        ${gradientColorOnHover} 100%
      )
    `};
        opacity: 0;
        transition: opacity 200ms ease;
        z-index: 1;
        pointer-events: none;
      }
    `}

  &:hover > div:first-of-type::after {
    opacity: 1;
  }
`;

interface IStyBorder {
  readonly gradientColor: string;
  readonly gradientColorOnHover: string;
  readonly keepHoverColorActive: boolean;
  readonly position: string;
}

export const StyBorder = styled.div<IStyBorder>`
  position: absolute;
  inset: 0;
  border-radius: ${RADIUS._4};
  padding: 1px;
  background: ${({
    gradientColor,
    gradientColorOnHover,
    keepHoverColorActive,
    position,
  }) => `
    linear-gradient(
      ${position},
      ${keepHoverColorActive ? gradientColorOnHover : gradientColor} 0%,
      transparent ${keepHoverColorActive ? '40%' : '30%'},
      transparent ${keepHoverColorActive ? '55%' : '65%'},
      ${keepHoverColorActive ? gradientColorOnHover : gradientColor} 100%
    )
  `};
  background-origin: border-box;
  background-clip: padding-box, border-box;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
`;

export const StyContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: ${RADIUS._4};
`;
